module.exports = __webpack_public_path__ + "img/nevados-advanced.2c6724a3.jpg";